import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PhotographerProfileService } from 'src/app/photographer/services/profile.service';
import { CountryService } from 'src/app/services/country.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { Constants } from 'src/app/helpers/constants';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { ContributorProfileEditModel } from 'src/app/photographer/models/contributor.profile.edit.model';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { ContributorIdentityFileModel } from '../../models/contributor.identity.file.model';
import { StripeAccountErrorComponent } from '../stripe-account-error/stripe.account.error.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class PhotographerProfileComponent implements OnInit {
    emailPattern = Constants.emailValidationRegEx;
    model = new ContributorProfileEditModel();
    countries = Array<SelectListItemModel>();
    currencies = Array<SelectListItemModel>();

    frontSideUploader: FileUploader;
    backSideUploader: FileUploader;
    otherUploader: FileUploader;

    identityFileFrontSide = new ContributorIdentityFileModel();
    identityFileBackSide = new ContributorIdentityFileModel();
    identityFileOther = new ContributorIdentityFileModel();

    phoneMask: string;
    maxDateOfBirth: any;
    minDateOfBirth: any;
    dob: any;


    constructor(private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private countryService: CountryService,
        private profileService: PhotographerProfileService,
        private authService: AuthService,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getCountries();
        this.getCurrencies();
        this.getContributorProfile();
        this.getIpAddress();
        this.phoneMask = Constants.phoneMask;

        this.frontSideUploader = new FileUploader({
            url: `${environment.apiUrl}/api/photographer/profile/upload-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.frontSideUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.frontSideUploader.onAfterAddingFile = this.onAfterFrontSideAddingFile;
        this.frontSideUploader.onCompleteAll = this.onCompleteAll;

        this.frontSideUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 1);
            form.append('contributorId', this.model.id);
        };

        this.backSideUploader = new FileUploader({
            url: `${environment.apiUrl}/api/photographer/profile/upload-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.backSideUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.backSideUploader.onAfterAddingFile = this.onAfterBackSideAddingFile;
        this.backSideUploader.onCompleteAll = this.onCompleteAll;

        this.backSideUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 2);
            form.append('contributorId', this.model.id);
        };

        this.otherUploader = new FileUploader({
            url: `${environment.apiUrl}/api/photographer/profile/upload-identity-image`,
            disableMultipart: false,
            formatDataFunctionIsAsync: false,
            allowedMimeType: ['image/jpeg', 'image/jpg'],
            autoUpload: false,
            authToken: `Bearer ${this.authService.getAuthToken()}`
        });

        this.otherUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed;
        this.otherUploader.onAfterAddingFile = this.onAfterOtherAddingFile;
        this.otherUploader.onCompleteAll = this.onCompleteAll;

        this.otherUploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('type', 3);
            form.append('contributorId', this.model.id);
        };

        const currentDate = new Date();
        this.minDateOfBirth = { year: 1800, month: 1, day: 1 };
        this.maxDateOfBirth = { year: currentDate.getFullYear(), month: (currentDate.getMonth() + 1), day: currentDate.getDate() };
    }

    getCountries() {
        this.ngxSpinner.show();
        this.countryService.getSelectList()
            .subscribe(response => {
                this.countries = response;
                this.ngxSpinner.hide();
            },
                error => {
                    console.error(error);
                    this.ngxSpinner.hide();
                    AppUtils.processErrorResponse(this.toastr, error);
                });
    }

    getCurrencies() {
        this.ngxSpinner.show();
        this.countryService.getCurrencySelectList()
            .subscribe(response => {
                this.currencies = response;
                this.ngxSpinner.hide();
            },
                error => {
                    console.error(error);
                    this.ngxSpinner.hide();
                    AppUtils.processErrorResponse(this.toastr, error);
                });
    }

    getContributorProfile() {
        this.ngxSpinner.show();
        this.profileService.getProfile()
            .subscribe(data => {
                Object.assign(this.model, data);
                if (this.model.dateOfBirth) {
                    this.dob = AppUtils.getNgDatePickerDate(this.model.dateOfBirth);
                }
                if (this.model.identityDocuments && this.model.identityDocuments.length !== 0) {
                    this.identityFileFrontSide = (this.model.identityDocuments.filter(x => x.type === 1))[0];
                    this.identityFileBackSide = (this.model.identityDocuments.filter(x => x.type === 2))[0];
                    this.identityFileOther = (this.model.identityDocuments.filter(x => x.type === 3))[0];
                } else {
                    this.identityFileFrontSide = null;
                    this.identityFileBackSide = null;
                    this.identityFileOther = null;
                }
                this.ngxSpinner.hide();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    submit() {
        this.ngxSpinner.show();
        this.model.dateOfBirth = AppUtils.getFormattedDate(this.dob);
        this.profileService.updateProfile(this.model).subscribe(
            () => {
                this.uploadImages();
                setTimeout(() => {
                    this.toastr.success('Your profile has been updated successfully');
                });
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
        this.toastr.info('Only jpg/jpeg images are allowed.');
    }

    onAfterFrontSideAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        if (this.identityFileFrontSide && this.identityFileFrontSide.id) {
            this.removeDocument(this.identityFileFrontSide.id);
            this.identityFileFrontSide = null;
        }
        const latestFile = this.frontSideUploader.queue[this.frontSideUploader.queue.length - 1];
        this.frontSideUploader.queue = [];
        this.frontSideUploader.queue.push(latestFile);
    }

    onAfterBackSideAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        if (this.identityFileBackSide && this.identityFileBackSide.id) {
            this.removeDocument(this.identityFileBackSide.id);
            this.identityFileBackSide = null;
        }
        const latestFile = this.backSideUploader.queue[this.backSideUploader.queue.length - 1];
        this.backSideUploader.queue = [];
        this.backSideUploader.queue.push(latestFile);
    }

    onAfterOtherAddingFile = (fileItem: FileItem) => {
        if (!fileItem.file.name.trim().toLowerCase().endsWith('.jpeg')
            && !fileItem.file.name.trim().toLowerCase().endsWith('.jpg')) {
            fileItem.remove();
            this.toastr.info('Only jpg/jpeg images are allowed.');
            return;
        }
        if (this.identityFileOther && this.identityFileOther.id) {
            this.removeDocument(this.identityFileOther.id);
            this.identityFileOther = null;
        }
        const latestFile = this.otherUploader.queue[this.otherUploader.queue.length - 1];
        this.otherUploader.queue = [];
        this.otherUploader.queue.push(latestFile);
    }

    onCompleteAll = () => {
        const forntSideFiledItems = this.frontSideUploader.queue.filter(x => x.isError);
        const backSideFailedItems = this.backSideUploader.queue.filter(x => x.isError);
        const otherFailedItems = this.otherUploader.queue.filter(x => x.isError);
        if (forntSideFiledItems.length === 0 && backSideFailedItems.length === 0 && otherFailedItems.length === 0) {
            this.ngxSpinner.hide();
            setTimeout(() => {
                this.toastr.success('Your profile has been updated successfully');
            });
        }
    }

    uploadImages() {
        let itemsToUpload = this.frontSideUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError);
        itemsToUpload = itemsToUpload.concat(this.backSideUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError));
        itemsToUpload = itemsToUpload.concat(this.otherUploader.queue.filter(x => !x.isUploaded || x.isCancel || x.isError));
        if (itemsToUpload.length === 0) {
            this.ngxSpinner.hide();
            setTimeout(() => {
                this.toastr.success('Your profile has been updated successfully');
            });
        }
        itemsToUpload.forEach(query => {
            query.upload();
        });
    }

    removeDocument(id: number) {
        this.model.documentsToRemove.push(id);
    }

    getIpAddress() {
        fetch(environment.ipifyApiEndPoint)
            .then(response => response.json())
            .then(result => {
                this.model.ipAddress = result.ip;
            })
            .catch(error => console.log('error', error));
    }

    onFileClick(event: any) {
        event.target.value = '';
    }

    openStripeAccountErrorModal(id: string) {
        const modal = this.modalService.open(StripeAccountErrorComponent);
        modal.componentInstance.id = id;
        modal.result.then(() => {
            this.getContributorProfile();
        });
    }

    refreshStripeAccountStatus(id: string) {
        this.ngxSpinner.show();
        this.profileService.refreshContributorStripeAccountStatus(id)
            .subscribe(res => {
                this.model.stripeAccountStatus = res;
                this.ngxSpinner.hide();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
